/**
 * Country / region list for artist signup and profile.
 * Codes are ISO 3166-1 alpha-2, plus EU for the Eurozone catch-all.
 */

export const COUNTRIES = [
  { code: 'GB', name: 'United Kingdom', label: '🇬🇧 United Kingdom – (£GBP)' },
  { code: 'IE', name: 'Ireland', label: '🇮🇪 Ireland – (€EUR)' },
  { code: 'US', name: 'United States', label: '🇺🇸 United States – ($USD)' },
  { code: 'CA', name: 'Canada', label: '🇨🇦 Canada – ($CAD)' },
  { code: 'AU', name: 'Australia', label: '🇦🇺 Australia – ($AUD)' },
  { code: 'NZ', name: 'New Zealand', label: '🇳🇿 New Zealand – ($NZD)' },
  { code: 'EU', name: 'Europe / Eurozone', label: '🇪🇺 Europe / Eurozone – (€EUR)' },
];

/**
 * Get country name by code
 */
export const getCountryName = (code) => {
  const country = COUNTRIES.find(c => c.code === code);
  return country ? country.name : code;
};

/**
 * Get country code by name (case-insensitive partial match)
 */
export const getCountryCode = (name) => {
  const country = COUNTRIES.find(c =>
    c.name.toLowerCase() === name.toLowerCase() ||
    c.name.toLowerCase().includes(name.toLowerCase())
  );
  return country ? country.code : null;
};

/**
 * Detect user's country using timezone (no external API calls)
 * Uses browser's timezone to guess the country
 */
export const detectUserCountry = () => {
  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log('🌍 Detected timezone:', timezone);

    if (timezone.includes('America/New_York') || timezone.includes('America/Chicago') ||
        timezone.includes('America/Denver') || timezone.includes('America/Los_Angeles') ||
        timezone.includes('America/Phoenix') || timezone.includes('America/Anchorage') ||
        timezone.includes('America/Honolulu')) {
      return 'US';
    }
    if (timezone.includes('Europe/London')) {
      return 'GB';
    }
    if (timezone.includes('America/Toronto') || timezone.includes('America/Vancouver') ||
        timezone.includes('America/Montreal') || timezone.includes('America/Winnipeg') ||
        timezone.includes('America/Edmonton') || timezone.includes('America/Halifax')) {
      return 'CA';
    }
    if (timezone.includes('Australia/')) {
      return 'AU';
    }
    if (timezone.includes('Europe/Dublin')) {
      return 'IE';
    }
    if (timezone.includes('Pacific/Auckland') || timezone.includes('Pacific/Chatham')) {
      return 'NZ';
    }
    if (timezone.includes('Europe/')) {
      return 'EU';
    }

    console.log('🌍 Using default country: US (timezone not recognized)');
    return 'US';
  } catch (error) {
    console.warn('⚠️ Timezone detection failed:', error);
    return 'US';
  }
};
